module.exports = __webpack_public_path__ + "img/times-circle-solid.bb7daa97.svg";